import React from 'react'
import { Card, Table, Empty } from 'antd'
import type { TableProps } from 'antd'
import './ProTable.css'

export interface ProTableProps<T> extends Omit<TableProps<T>, 'title'> {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  extra?: React.ReactNode
  filters?: React.ReactNode
  headerBordered?: boolean
  className?: string
}

export function ProTable<T extends object>({
  title,
  subtitle,
  extra,
  filters,
  columns,
  dataSource,
  loading,
  pagination,
  rowKey = 'id',
  className = '',
  ...restProps
}: ProTableProps<T>) {
  return (
    <Card className={`admin-pro-table-card cstore-pro-table-card ${className}`} bordered={false}>
      {(title || extra || filters) && (
        <div className="pro-table-header-wrapper">
          <div className="pro-table-title-row">
            <div>
              {title && <div className="pro-table-title">{title}</div>}
              {subtitle && <div className="pro-table-subtitle">{subtitle}</div>}
            </div>
            {extra && <div className="pro-table-extra">{extra}</div>}
          </div>
          {filters && <div className="pro-table-filters">{filters}</div>}
        </div>
      )}

      <div className="pro-table-body">
        <Table<T>
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          rowKey={rowKey}
          locale={{
            emptyText: <Empty description="暂无相关数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
          }}
          pagination={
            pagination === false
              ? false
              : {
                  showQuickJumper: true,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50', '100'],
                  showTotal: (total) => `共 ${total} 条数据`,
                  ...pagination,
                }
          }
          {...restProps}
        />
      </div>
    </Card>
  )
}

export default ProTable
